"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _apolloCacheInmemory = require("apollo-cache-inmemory");

var _default = new _apolloCacheInmemory.InMemoryCache({
  cacheRedirects: {
    Query: {}
  }
});

exports["default"] = _default;